var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaceBookSocialMedia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#021F36"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 10H13.75C11.6797 10 10 11.6797 10 13.75V26.25C10 28.3203 11.6797 30 13.75 30H20.6771V22.2526H18.0729V19.2318H20.6771V17.0052C20.6771 14.4271 22.2656 13.0208 24.5703 13.0208C25.6641 13.0208 26.6146 13.099 26.888 13.138V15.8333L25.2995 15.8464C24.0365 15.8464 23.8021 16.4323 23.8021 17.3047V19.2318H26.7839L26.3932 22.2526H23.8021V30H26.25C28.3203 30 30 28.3203 30 26.25V13.75C30 11.6797 28.3203 10 26.25 10Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceBookSocialMedia);
export default __webpack_public_path__ + "static/media/FaceBookSocialMedia.fac88a307c4deb4e279f4896aa5fe109.svg";
export { ForwardRef as ReactComponent };